import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface StartDateValidationAlertProps {
  startDateValidation: any;
  isEditing: boolean;
}

export const StartDateValidationAlert: React.FC<
  StartDateValidationAlertProps
> = ({ startDateValidation, isEditing }) => {
  if (!isEditing || !startDateValidation) {
    return null;
  }

  return (
    <Alert
      variant={startDateValidation.isValid ? "default" : "destructive"}
      className="mt-2"
    >
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Start Date Change Impact</AlertTitle>
      <AlertDescription>
        <div className="space-y-2">
          <p>
            • {startDateValidation.impact.paymentsAffected} payments will be
            affected
          </p>
          <p>
            • {startDateValidation.impact.periodsAffected} subscription periods
            will be recalculated
          </p>
          {startDateValidation.warnings.map(
            (warning: string, index: number) => (
              <p key={index}>⚠️ {warning}</p>
            ),
          )}
          {startDateValidation.recommendations.map(
            (rec: string, index: number) => (
              <p key={index}>💡 {rec}</p>
            ),
          )}
        </div>
      </AlertDescription>
    </Alert>
  );
};
